module.exports = __webpack_public_path__ + "img/logo-ruinart-art@2x.0dafd068.png";